export default function initArticleToc() {

  // Bail if this JS is loaded outside of WordPress
  if (CC_CONSTANTS.isNonWp) {
      console.cclog('[Article Toc Debug] loaded outside of WP, skipping...');
		return;
	}

	// Get the ToC element.
	const toc = document.querySelector( '.article-toc-region .toc' );
	if ( ! toc ) {
		return;
	}

	// Get the links in the ToC.
	const links = [ ...toc.querySelectorAll( '.toc-item a[href^="#"]' ) ];
	if ( links.length === 0 ) {
		return;
	}

	// Create a map of links by their ID.
	const sections = [];
	const linkById = new Map();

	// Add the links to the map.
	for ( const link of links ) {
		const hash = link.getAttribute( 'href' );
		if ( ! hash || hash === '#' ) {
			continue;
		}

		const id = decodeURIComponent( hash.slice( 1 ) );
		const section = document.getElementById( id );
		if ( ! section ) {
			continue;
		}

		sections.push( section );
		linkById.set( id, link );
	}

	if ( sections.length === 0 ) {
		return;
	}

	// Scroll buffer to prevent the active link from being too close to the top of the viewport, uses computed scroll-margin-top
	// In pixels
	const SCROLL_BUFFER = 50;
	let activeId = null;

	// Debounce to limit the frequency.
	// In milliseconds
	const debounce = ( callback, delay = 50 ) => {
		let timeoutId;
		return ( ...args ) => {
			clearTimeout( timeoutId );
			timeoutId = setTimeout( () => callback( ...args ), delay );
		};
	};

	// Get the scroll offset of the first heading in the ToC.
	function getTocScrollOffset() {
		const heading = sections.find( ( section ) => section.matches( 'h1, h2, h3, h4, h5, h6' ) ) || sections[ 0 ];
		const marginTop = parseFloat( getComputedStyle( heading ).scrollMarginTop );
		return Number.isFinite( marginTop ) ? marginTop : 0;
	}

	// Set the active link in the ToC.
	function setActive( id, scrollTocLink = false ) {
		if ( ! id || ! linkById.has( id ) ) {
			return;
		}

		if ( activeId === id ) {
			return;
		}

		activeId = id;

		for ( const link of links ) {
			const item = link.closest( '.toc-item' );
			const linkId = decodeURIComponent( ( link.getAttribute( 'href' ) || '' ).slice( 1 ) );
			const isActive = linkId === id;

			item?.classList.toggle( 'is-active', isActive );

			if ( isActive ) {
				link.setAttribute( 'aria-current', 'location' );
				if ( scrollTocLink ) {
					link.scrollIntoView( { block: 'nearest' } );
				}
			} else {
				link.removeAttribute( 'aria-current' );
			}
		}
	}

	// Update the active link in the ToC from scroll.
	function updateActiveFromScroll() {
		const offset = getTocScrollOffset() + SCROLL_BUFFER;
		let currentId = sections[ 0 ].id;

		for ( const section of sections ) {
			if ( section.getBoundingClientRect().top <= offset ) {
				currentId = section.id;
			}
		}

		setActive( currentId );
	}

	// Sync the active link in the ToC from the hash.
	function syncFromHash( scrollTocLink = false ) {
		const hash = window.location.hash;
		if ( ! hash ) {
			return;
		}

		const id = decodeURIComponent( hash.slice( 1 ) );
		if ( linkById.has( id ) ) {
			setActive( id, scrollTocLink );
		}
	}

	// On scroll, update the active link in the ToC.
	const onScroll = debounce( updateActiveFromScroll, 50 );

	for ( const link of links ) {
		link.addEventListener( 'click', () => {
			const id = decodeURIComponent( ( link.getAttribute( 'href' ) || '' ).slice( 1 ) );
			setActive( id, true );
		} );
	}

	// On hash change, sync the active link in the ToC.
	window.addEventListener( 'hashchange', () => syncFromHash( false ) );
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', onScroll, { passive: true } );

	if ( window.location.hash ) {
		syncFromHash( false );
	} else {
		updateActiveFromScroll();
	}
}
